<template>
  <!-- 审批审核 -->
  <div class="approve-clue" v-loading="loading || submitting">
    <el-form
      ref="formRef"
      :model="formData"
      label-position="top"
      style="padding-top: 20px;"
    >
      <!-- 将该线索 -->
      <el-form-item
        v-if="(showFormFieldKeyInfo.next_code_formCode_FR016 || {}).isShow"
        :label="(showFormFieldKeyInfo.next_code_formCode_FR016 || {}).zhName || ''"
        prop="next_code_formCode_FR016"
        :rules="[
          {
            required: (showFormFieldKeyInfo.next_code_formCode_FR016 || {}).required,
            message: '请选择',
            trigger: 'change'
          }
        ]"
      >
        <el-radio-group v-model="formData.next_code_formCode_FR016" class="handle-radio-group">
          <el-radio
            v-for="item in resultNextCodeList"
            :key="item.questionItemBalue"
            :label="item.questionItemValue"
          >{{ item.questionItemLabel + (resultApplyAction === item.questionItemValue ? '(申请选项)' : '') }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 选择跟进人 -->
      <el-form-item
        v-if="formData.next_code_formCode_FR016 === 'end_new' && (showFormFieldKeyInfo.new_work_number_formCode_FR016 || {}).isShow"
        :label="(showFormFieldKeyInfo.new_work_number_formCode_FR016 || {}).zhName || ''"
        prop="new_work_number_formCode_FR016"
        :rules="[
          { 
            required: (showFormFieldKeyInfo.new_work_number_formCode_FR016 || {}).required,
            message: '请选择',
            trigger: 'change'
          }
        ]"
      >
        <el-select
          v-model="formData.new_work_number_formCode_FR016"
          placeholder="请选择"
          filterable
          remote
          :remote-method="remoteSearchEmployee"
          :loading="employeeLoading"
          size="small"
          class="form-select"
        >
          <el-option v-for="item in filteredEmployeeOptions" :key="item.workNumber" :label="item.nickName" :value="item.workNumber"></el-option>
        </el-select>
      </el-form-item>

      <custom-form-item
        type="textarea"
        prop="reject_cause_formCode_FR016"
        v-model="formData.reject_cause_formCode_FR016"
        :fieldInfo="(showFormFieldKeyInfo.reject_cause_formCode_FR016 || {})"
        placeholder="请输入..."
      />
    </el-form>
  </div>
</template>
 
<script>
  const approveFormCode = 'FR016'
  import request from '@/utils/request'
  import utils from '@/views/DoctorVisitLTC/utils/index'
  import formFlow from '@/views/DoctorVisitLTC/common/formFlow'
  import CustomFormItem from '@/views/DoctorVisitLTC/components/customFormItem/CustomFormItem.vue'

  // 选项与线索的枚举值对应关系
  const applyActionInfo = {
    S070: 'end_2',
    S030: 'S030'
  }
  export default {
    name: 'ApproveClueApply',
    data() {
      return {
        formData: {
          ['check_record_id_formCode_' + approveFormCode]: '', // 审批记录ID
          ['doctor_id_formCode_' + approveFormCode]: '', // 医生id
          ['next_code_formCode_' + approveFormCode]: '', // 将该线索
          ['check_status_formCode_' + approveFormCode]: '', // 审批状态
          ['reject_cause_formCode_' + approveFormCode]: '', // 审核原因
          ['new_work_number_formCode_' + approveFormCode]: '', // 新跟进人
        },
        fieldList: [],
        showFormFieldKeyInfo: {}, // 表单字段信息
        originOptionsInfo: {},
        employeeOptions: [],
        employeeLoading: false,
        searchKeyword: '',
        loading: false,
        submitting: false // 防止重复提交
      }
    },
    methods: {
      async getFormFieldList(formCodeList) {
        try {
          this.loading = true
          const {
            formData,
            showFormFieldKeyInfo,
            originOptionsInfo,
            fieldList,
            optionsInfo
          } = await formFlow.getFormFieldList(formCodeList)
          const formIdOfCheckRecordId = await formFlow.createFormId()
          this.formData = {
            ...formData,
            ['check_record_id_formCode_' + approveFormCode]: formIdOfCheckRecordId
          }
          this.originOptionsInfo = originOptionsInfo
          this.fieldList = fieldList
          this.showFormFieldKeyInfo = showFormFieldKeyInfo
          // console.log({formData, showFormFieldKeyInfo, originOptionsInfo, fieldList, optionsInfo})
        } catch (error) {
          console.log('获取表单字段信息失败:', error)
        } finally {
          this.loading = false
        }
      },

      async getEmployeeOptions() {
        const params = {}
        try {
          const res = await request.get('/cluepool/pc/user/all', params, '')
          if(res.code === 200) {
            this.employeeOptions = res.data || []
          } else {
            this.$message.error(res.message)
          }
        } catch (error) {
          console.log('请求员工列表数据请求失败', error)
        }
      },

      // 远程搜索员工
      remoteSearchEmployee(query) {
        if (query !== '') {
          this.employeeLoading = true
          this.searchKeyword = query
          // 模拟远程搜索延迟，优化用户体验
          setTimeout(() => {
            this.employeeLoading = false
          }, 200)
        } else {
          this.searchKeyword = ''
          this.employeeLoading = false
        }
      },
      /**
       * 提交审核表单
       * @returns {Promise<boolean>} 提交是否成功
       */
      async submitHandle() {
        // 防止重复提交
        if (this.submitting) {
          return false
        }

        let isFinish = false
        
        try {
          // 表单验证
          const valid = await this.$refs.formRef.validate()
          
          if (!valid) {
            return false
          }

          // 开始提交
          this.submitting = true
          const { fieldList, formData } = this || {}
          const { doctorId, doctorStageId, applyAction, stepId } = this.currentClueInfo
          const resultFormCodeList = [approveFormCode]
          const resultFormData = []
          try {
            for (const formCode of resultFormCodeList) {
              resultFormData.push({
                formCode,
                fieldData: fieldList.filter(item => item.formCode === formCode).map(item => {
                  let value = []
                  if (['doctor_id'].includes(item.fieldName)) {
                    // 处理doctor_id字段
                    value = utils.isEmpty(doctorId) ? [] : [doctorId]
                  } else if (item.fieldName === 'new_work_number') {
                    // 新跟进人
                    value = formData['next_code_formCode_' + approveFormCode] === 'end_new'
                            ? utils.isEmpty(formData[item.resultFieldName]) ? [] : [formData[item.resultFieldName]]
                            : []
                  } else if (item.fieldName === 'check_status') {
                    // 审批状态(目前传入固定的值)
                    value = ['agree']
                  } else {
                    if (item.inputType === 2) {
                      // 多选
                      value = utils.isEmpty(formData[item.resultFieldName]) ? [] : formData[item.resultFieldName]
                    } else {
                      value = utils.isEmpty(formData[item.resultFieldName]) ? [] : [formData[item.resultFieldName]]
                    }
                  }
                  return {
                    formFieldCode: item.fieldCode,
                    fieldName: item.fieldName,
                    zhName: item.zhName,
                    value
                  }
                })
              })
            }
          } catch (error) {
            console.log('组装表单请求参数数据失败:', error)
          }
          const params = {
            flowInstanceId: doctorStageId,
            followAction: this.formData['next_code_formCode_' + approveFormCode],
            formData: resultFormData,
            stepCode: applyAction,
            stepId: stepId
          }
          const res = await formFlow.submitFormData(params)
          isFinish = true
          return res.code === 200
        } catch (error) {
          console.log('审核提交失败：', error)
          isFinish = false
          return false
        } finally {
          // 重置提交状态
          this.submitting = false
        }
      },

      /**
       * 重置表单
       */
      resetForm() {
        this.$refs.formRef.resetFields()
      }
    },
    async created() {
      const formCodeList = [approveFormCode]
      await this.getFormFieldList(formCodeList)
      this.getEmployeeOptions()
      // 如果是转公海，则默认勾选上“转入公海推进池”
      // 如果是转长期维护，则默认勾选上“转入长期维护”
      if (this.currentClueInfo) {
        this.formData['next_code_formCode_' + approveFormCode] = applyActionInfo[this.currentClueInfo.applyAction]
        console.log(this.formData)
      }
    },
    props: {
      currentClueInfo: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      // 远程搜索过滤后的员工列表
      filteredEmployeeOptions() {
        if (!this.searchKeyword) {
          return []
        }
        const keyword = this.searchKeyword.toLowerCase()
        return this.employeeOptions.filter(item =>
          (item.nickName || '').toString().toLowerCase().includes(keyword) ||
          (item.workNumber || '').toString().toLowerCase().includes(keyword)
        ).slice(0, 60)
      },
      resultNextCodeList() {
        return this.originOptionsInfo.next_code_formCode_FR016 || []
      },
      resultApplyAction() {
        return applyActionInfo[this.currentClueInfo.applyAction]
      }
    },
    components: {
      CustomFormItem
    },
  }
 
</script>

<style scoped lang='less'>
.approve-clue {
  padding: 0 20px;
  min-height: 100px;
  .handle-radio-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    /deep/ .el-radio {
      margin-right: 0;
      height: auto;
      line-height: 1.5;
    }
  }
}
</style>